import { Box, Container, styled } from '@mui/material';
import { TaskContext } from '../../context/TaskContext';

export const StyledTaskContextProvider = styled(TaskContext.Provider)({});

export const StyledTaskMessageBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
}));

export const StyledTaskLayout = styled(Box)({
  background:
    'linear-gradient(254.7deg, #FFFFFF 50.36%, rgba(255, 255, 255, 0) 120.31%), url(/images/login-white-bg.jpg)',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledTaskLayoutContainer = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '90%',
});
